var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProceedChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10 5L8.59 6.41 13.17 11l-4.58 4.59L10 17l6-6z",
    fillRule: "evenodd"
  })));
}
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSAiZGF0YTppbWFnZS9zdmcreG1sLCUzY3N2ZyB3aWR0aD0nMjRweCcgaGVpZ2h0PScyNHB4JyB2aWV3Qm94PScwIDAgMjQgMjQnIHZlcnNpb249JzEuMScgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJyUzZSAlM2NnIGlkPSdpY29ucy9wcm9jZWVkX2NoZXZyb24nIHN0cm9rZT0nbm9uZScgc3Ryb2tlLXdpZHRoPScxJyBmaWxsPSdub25lJyBmaWxsLXJ1bGU9J2V2ZW5vZGQnJTNlICUzY3BvbHlnb24gaWQ9J1BhdGgnIGZpbGw9JyUyM0ZGRkZGRicgcG9pbnRzPScxMCA1IDguNTkgNi40MSAxMy4xNyAxMSA4LjU5IDE1LjU5IDEwIDE3IDE2IDExJyUzZSUzYy9wb2x5Z29uJTNlICUzYy9nJTNlICUzYy9zdmclM2Ui";
export { SvgProceedChevron as ReactComponent };